import slide1Mobile from './images/slides/slide-1-mobile.jpg';
import slide2Mobile from './images/slides/slide-2-mobile.jpg';
import slide3Mobile from './images/slides/slide-3-mobile.jpg';
import slide1Desktop from './images/slides/slide-1-desktop.jpg';
import slide2Desktop from './images/slides/slide-2-desktop.jpg';
import slide3Desktop from './images/slides/slide-3-desktop.jpg';

const slides = [
  {
    name: 'Step 1',
    mobile: slide1Mobile,
    desktop: slide1Desktop,
  },
  {
    name: 'Step 2',
    mobile: slide2Mobile,
    desktop: slide2Desktop,
  },
  {
    name: 'Step 3',
    mobile: slide3Mobile,
    desktop: slide3Desktop,
  },
];

export default slides;
